module.exports = __webpack_public_path__ + "static/media/germany_18269.31af1bdf.png";